import { Select } from '@iwoca/orion';
import { useLingui } from '@lingui/react/macro';
import { clsx } from 'clsx';
import { useFormContext } from 'react-hook-form';

import styles from './CompanyInputManualDE.module.css';
import { TGetStateResponseCompanyDE } from '../../../../../lapiOverrideTypesDE';
import { TCompanyDetailsDataDE } from '../../CompanyDetailsDE';

const DE_COMPANY_TYPE: {
  label: string;
  value: TGetStateResponseCompanyDE['type'];
}[] = [
  {
    label: 'Freiberufler',
    value: 'freiberufler',
  },
  {
    label: 'Gewerbebetrieb (nicht eingetragene Einzelfirma)',
    value: 'gewerbebetrieb',
  },
  {
    label: 'Eingetragene Einzelfirma',
    value: 'gewerbebetrieb_eingtr',
  },
  {
    label: 'e.K.',
    value: 'ek',
  },
  {
    label: 'Eingetragene Genossenschaft (e.G.)',
    value: 'eg',
  },
  {
    label: 'GbR/BGB-Gesellschaft',
    value: 'gbr',
  },
  {
    label: 'oHG',
    value: 'ohg',
  },
  {
    label: 'KG',
    value: 'kg',
  },
  {
    label: 'Partnerschaft',
    value: 'partnerschaft',
  },
  {
    label: 'Gemeinnütziger Verein e.V.',
    value: 'gemeinnuetziger_verein',
  },
  {
    label: 'Nicht gemeinnütziger Verein',
    value: 'nicht_gemeinnuetziger_verein',
  },
  {
    label: 'UG',
    value: 'ug',
  },
  {
    label: 'GmbH',
    value: 'gmbh',
  },
  {
    label: 'Gmbh & Co. KG',
    value: 'gmbh_u_co_kg',
  },
  {
    label: 'AG',
    value: 'aktiengesellschaft',
  },
  {
    label: 'Ltd. (mit dt. Niederlassung)',
    value: 'ltd',
  },
  {
    label: 'KGaA',
    value: 'kgaa',
  },
];

const CompanyLegalFormDE = () => {
  const { t } = useLingui();

  const {
    register,
    formState: { errors },
  } = useFormContext<TCompanyDetailsDataDE>();

  return (
    <div className={styles.formFieldGroup}>
      <Select
        {...register('legalForm')}
        label={t`What legal form does your company have?`}
        placeholder={t`Please select`}
        error={errors?.legalForm?.message}
        className={clsx(
          {
            [styles.erroredSelect]: errors.legalForm?.message,
          },
          'fs-mask',
        )}
      >
        {DE_COMPANY_TYPE.map((companyType) => (
          <option
            key={companyType.value}
            value={companyType.value}
            className="fs-mask dd-privacy-mask"
          >
            {companyType.label}
          </option>
        ))}
      </Select>
    </div>
  );
};

export default CompanyLegalFormDE;
